import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { QueryParamsModel } from '../../_base/crud';
import { Note } from '../_models/note.model';
import { NoteActions, NoteActionTypes } from '../_actions/note.action';

export interface NoteState extends EntityState<Note> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<Note> = createEntityAdapter<Note>({
  selectId: (note) => note.id,
});

export const initialNoteState: NoteState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function noteReducer(state = initialNoteState, action: NoteActions): NoteState {
  switch (action.type) {
    case NoteActionTypes.ToggleNotePageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case NoteActionTypes.ToggleNoteActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case NoteActionTypes.LoadNotePage:
      return adapter.addMany(action.payload.notes, {
        ...initialNoteState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case NoteActionTypes.CancelNotePage:
      return { ...state, query: new QueryParamsModel({}) };

    case NoteActionTypes.CreateNote:
      return adapter.addOne(action.payload.note, state);

    case NoteActionTypes.UpdateNote:
      return adapter.updateOne(action.payload.note, state);

    case NoteActionTypes.ThrowNoteError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case NoteActionTypes.ClearNoteError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
